// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as OrderFareV2ApiModel from "../api-model/OrderFareV2ApiModel.bs.js";

function decodeFare(fare, fare_type) {
  var tmp;
  if (fare_type !== 1) {
    tmp = undefined;
  } else {
    var value = fare.fare_with_dues;
    tmp = value !== undefined ? Caml_option.some(Currency.toCurrency(value)) : Curry._1(ErrorUtils$Catalyst.raiseError("OrderFareV2EntityMapper.re", "fare_with_dues key missing for completed order", undefined), undefined);
  }
  return {
          partner_trip_fare: Currency.toCurrency(fare.partner_trip_fare),
          porter_bearing_total_discount: Currency.toCurrency(fare.porter_bearing_total_discount),
          trip_fare: Currency.toCurrency(fare.trip_fare),
          pre_trip_fare_round_off: Belt_Option.mapWithDefault(fare.pre_trip_fare_round_off, undefined, (function (v) {
                  return Caml_option.some(Currency.toCurrency(v));
                })),
          base_fare: Currency.toCurrency(fare.base_fare),
          distance_charge: Currency.toCurrency(fare.distance_charge),
          travel_duration_charge: Currency.toCurrency(fare.travel_duration_charge),
          waiting_charge: Currency.toCurrency(fare.waiting_charge),
          flat_surge_amount: Currency.toCurrency(fare.flat_surge_amount),
          waiting_time: fare.waiting_time,
          travel_distance: fare.travel_distance,
          travel_duration: fare.travel_duration,
          pickup_extra_charge: Currency.toCurrency(fare.pickup_extra_charge),
          drop_extra_charge: Currency.toCurrency(fare.drop_extra_charge),
          convenience_charge: Currency.toCurrency(fare.convenience_charge),
          toll: Currency.toCurrency(fare.toll),
          road_tax: Currency.toCurrency(fare.road_tax),
          environmental_tax: Currency.toCurrency(fare.environmental_tax),
          toll_breakup_details: List.map((function (param) {
                  return {
                          title: param.title,
                          amount: Currency.toCurrency(param.amount)
                        };
                }), fare.toll_breakup_details),
          referral_discount: Currency.toCurrency(fare.referral_discount),
          coupon_discount: Currency.toCurrency(fare.coupon_discount),
          subscription_discount: Currency.toCurrency(fare.subscription_discount),
          credit_charge: Currency.toCurrency(fare.credit_charge),
          vat: Belt_Option.mapWithDefault(fare.vat, undefined, (function (f) {
                  return Caml_option.some(Currency.toCurrency(f));
                })),
          helper_charge: Currency.toCurrency(fare.helper_charge),
          helper_plus_labour_charge: Currency.toCurrency(fare.helper_plus_labour_charge),
          waypoints: fare.waypoints,
          waypoint_charge: Currency.toCurrency(fare.waypoint_charge),
          tax_on_commission: Currency.toCurrency(fare.tax_on_commission),
          loading_time: fare.loading_time,
          unloading_time: fare.unloading_time,
          fare_type: fare_type,
          fare_with_dues: tmp,
          courier_fee: Belt_Option.mapWithDefault(fare.courier_fee, undefined, (function (f) {
                  return Caml_option.some(Currency.toCurrency(f));
                }))
        };
}

var Fare = {
  decodeFare: decodeFare
};

function decodeAmount(amount) {
  return Currency.toCurrency(amount.amount);
}

function decodeOnlinePayment(breakup) {
  if (breakup !== undefined) {
    return {
            amount: Currency.toCurrency(breakup.online_payment_details.amount),
            breakup_details: {
              cashback: Currency.toCurrency(breakup.online_payment_details.breakup_details.cashback.amount),
              porter_credits: Currency.toCurrency(breakup.online_payment_details.breakup_details.porter_credits.amount),
              paytm: Currency.toCurrency(breakup.online_payment_details.breakup_details.paytm.amount),
              instamojo: Currency.toCurrency(breakup.online_payment_details.breakup_details.instamojo.amount),
              razorpay: Currency.toCurrency(breakup.online_payment_details.breakup_details.razorpay.amount),
              business_account: Currency.toCurrency(breakup.online_payment_details.breakup_details.business_account.amount),
              muneemji: Currency.toCurrency(breakup.online_payment_details.breakup_details.muneemji.amount)
            }
          };
  } else {
    return Curry._1(ErrorUtils$Catalyst.raiseError("OrderFareV2EntityMapper.re", "Online Payment breakup details key missing", undefined), undefined);
  }
}

function decodePayment(fare) {
  var f = fare.breakup_details;
  var f$1 = fare.online_paid_amount_with_discount;
  return {
          online_payment: decodeOnlinePayment(fare.breakup_details),
          driver_collected_cash: f !== undefined ? Currency.toCurrency(f.actual_driver_collected_cash.amount) : Curry._1(ErrorUtils$Catalyst.raiseError("OrderFareV2EntityMapper.re", "driver_collected_cash key missing", undefined), undefined),
          online_paid_amount_with_discount: f$1 !== undefined ? Currency.toCurrency(f$1) : Curry._1(ErrorUtils$Catalyst.raiseError("OrderFareV2EntityMapper.re", "online_paid_amount_with_discount key missing", undefined), undefined)
        };
}

var Payment = {
  decodeAmount: decodeAmount,
  decodeOnlinePayment: decodeOnlinePayment,
  decodePayment: decodePayment
};

function decodePricing(pricing) {
  if (pricing !== undefined) {
    return List.map((function (p) {
                  return {
                          lower_km: p.lower_km,
                          upper_km: p.upper_km,
                          price_per_km: Currency.toCurrency(p.price_per_km),
                          price_per_min: Currency.toCurrency(p.price_per_min)
                        };
                }), pricing);
  } else {
    return Curry._1(ErrorUtils$Catalyst.raiseError("OrderFareV2EntityMapper.re", "distance time pricing key missing", undefined), undefined);
  }
}

var Pricing = {
  decodePricing: decodePricing
};

function execute(json) {
  var fare = DeccoUtils$Catalyst.resolveResult(OrderFareV2ApiModel.t_decode(json), "OrderFareV2EntityMapper.re");
  return {
          vendor: Belt_Option.mapWithDefault(fare.order_fares.vendor, undefined, (function (f) {
                  return decodeFare(f, /* Vendor */2);
                })),
          customer: Belt_Option.mapWithDefault(fare.order_fares.customer, undefined, (function (f) {
                  return {
                          fare: decodeFare(f, /* Customer */1),
                          payment: decodePayment(f),
                          pricing: decodePricing(f.distance_time_pricing_info)
                        };
                })),
          fixed_fallback: Belt_Option.mapWithDefault(fare.order_fares.fixed_fallback, undefined, (function (f) {
                  return decodeFare(f, /* FixedFallback */4);
                })),
          estimated: decodeFare(fare.order_fares.estimated, /* Estimated */0),
          default_fare: Belt_Option.mapWithDefault(fare.order_fares.default, undefined, (function (f) {
                  return decodeFare(f, /* Default */3);
                }))
        };
}

export {
  Fare ,
  Payment ,
  Pricing ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
